import { useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { IconHelp } from '../../icon/IconHelp';
import { IconButton } from '../../input/IconButton';
import { Flex } from '../../layout/Flex';
import { StatisticInfoDrawer } from './parts/StatisticInfoDrawer/StatisticInfoDrawer';
import { BusinessStatisticInfoProps } from './types';

export const BusinessStatisticInfo = ({
    title,
    children,
    moreUrl,
    statisticUrl,
    hasCloseButton,
    onAllStatisticClick,
    ...other
}: BusinessStatisticInfoProps) => {
    const [visibleStatInfo, setVisibleStatInfo] = useState(false);

    const openStatInfo = useCallback(() => setVisibleStatInfo(true), []);
    const closeStatInfo = useCallback(() => setVisibleStatInfo(false), []);

    return (
        <Flex {...other}>
            <IconButton onClick={openStatInfo}>
                <IconHelp color="var(--color-primary)" size={16} />
            </IconButton>
            {visibleStatInfo
                ? createPortal(
                      <StatisticInfoDrawer
                          title={title}
                          content={children}
                          moreUrl={moreUrl}
                          statisticUrl={statisticUrl}
                          hasCloseButton={hasCloseButton}
                          onClose={closeStatInfo}
                          onAllStatisticClick={onAllStatisticClick}
                      />,
                      window.document.body,
                  )
                : null}
        </Flex>
    );
};
